var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDocumentIcon = function SvgDocumentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "-4 -2 36 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#707070",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.076 4a2.77 2.77 0 0 1 2.77 2.77v18.46a2.77 2.77 0 0 1-2.77 2.77H4.923a2.77 2.77 0 0 1-2.77-2.77V6.77A2.77 2.77 0 0 1 4.923 4zm.923 4.615h-24v16.616c0 .51.415.923.923.923h22.154c.51 0 .923-.414.923-.923V8.615z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.153 10.462v13.846H5.845V10.462h20.308zm-.923.923H6.768v12H25.23v-12z"
  }))));
};

export default SvgDocumentIcon;